import {useListingFilters} from "@/utils/listing-utils.ts";


export default function AlphaFilter() {
    const { search, setLetter } = useListingFilters();

    const alphabet = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
    ];

    //The design calls for simultaneously displaying "A-Z" in the filter
    //AND having "All Letters" as the first option. To accomplish this,
    //the first option, "A-Z" is disabled but visible. Both it
    //and the "All Letters" option should reset the letter filter.
    const selectedValue = search?.letter ?? '__placeholder__';

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setLetter(value === '__all__' ? undefined : value);
    };

    return (
        <div className="Finder__filter-toggle h5 alpha-filter">
                <select id="letter" name="letter" onChange={handleChange} value={selectedValue}>
                    <option value="__placeholder__" disabled hidden>
                        A-Z
                    </option>

                    <option value="__all__">
                        All Letters
                    </option>
                    { alphabet.map((letter) => <option value={letter} key={`letter-${letter}`}>{letter}</option>) }
                </select>
            <svg
                className="Finder__select-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="19"
                aria-hidden="true"
            >
                <path d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z" />
            </svg>
        </div>
    );
}